export const defaultSortingFn = (rowA: any, rowB: any, columnId: any) => {
  const firstValue: string = rowA?.original?.[columnId]?.toString() || '';
  const secondValue: string = rowB?.original?.[columnId]?.toString() || '';

  return firstValue.localeCompare(secondValue);
};

export const sortUserName = (rowA: any, rowB: any) => {
  const firstValue: string = rowA?.original?.lname?.toString() || '';
  const secondValue: string = rowB?.original?.lname?.toString() || '';

  return firstValue.localeCompare(secondValue);
};

export const sortUserEmail = (rowA: any, rowB: any) => {
  const firstValue: string = rowA?.original?.email?.toString() || '';
  const secondValue: string = rowB?.original?.email?.toString() || '';

  return firstValue.localeCompare(secondValue);
};

export const sortUserPhoneNumber = (rowA: any, rowB: any) => {
  const firstValue: string = rowA?.original?.phone_number?.toString() || '';
  const secondValue: string = rowB?.original?.phone_number?.toString() || '';

  return firstValue.localeCompare(secondValue);
};

export const userSortingFn = (rowA: any, rowB: any, userColumn: string) => {
  const firstValue: string =
    rowA?.original?.user?.[userColumn]?.toString() || '';
  const secondValue: string =
    rowB?.original?.user?.[userColumn]?.toString() || '';

  return firstValue.localeCompare(secondValue);
};

export const userPhoneSortingFn = (rowA: any, rowB: any) =>
  userSortingFn(rowA, rowB, 'phone_number');
export const userIdSortingFn = (rowA: any, rowB: any) =>
  userSortingFn(rowA, rowB, 'id');
export const userEmailSortingFn = (rowA: any, rowB: any) =>
  userSortingFn(rowA, rowB, 'email');
export const assignedAdvisorSortingFn = (rowA: any, rowB: any) => {
  const firstValue = rowA.getValue('assigned_advisor_id');
  const secondValue = rowB.getValue('assigned_advisor_id');

  // Sort null values to the end
  if (firstValue === null && secondValue === null) return 0;
  if (firstValue === null) return 1;
  if (secondValue === null) return -1;

  return firstValue - secondValue;
};

export const clientNameSortingFn = (rowA: any, rowB: any) => {
  const firstValue: string = rowA?.original?.name;
  const secondValue: string = rowB?.original?.name;

  return firstValue.localeCompare(secondValue);
};
